import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { CommonLinkDesktop as CommonLink } from '../../common-link/desktop';
import type { TDropDownDesktop, IDepsDesktop } from '../models';

import { DropDownDesktop as Component } from './drop-down-desktop';
import styles from './styles.css';

export const DropDownDesktop = createWidget<IDepsDesktop, TDropDownDesktop>({ styles, CommonLink })(
    Component
);
